const DARK = {
  100: "#23272a",
  200: "#383b3e",
  300: "#4d5153",
  400: "#64676a",
  500: "#7c7f81",
  600: "#959799",
};

const lightThemePalette = {
  mode: "light",
  primary: {
    main: "#485696",
    light: "#e7e7e7",
  },
  secondary: {
    main: "#fc7a1e",
    light: "#f9c784",
    dark: "#f24c00",
  },

  background: {
    paper: "#ffffff",
    default: "#ffffff",
    neutral: "#272643",
  },
};

export default lightThemePalette;
